import { AccountTypeValue } from "../enums/account-type.enum";

export class AccountTypeConstants {
    public static accountTypes = [
        { name: 'Direct',value: AccountTypeValue.direct }
    ];
    
}


// WEBPACK FOOTER //
// ./src/app/common/constants/account-type-constants.ts